import React from 'react';
import { Box } from '@ntuctech/devex-tangram';
import styled from 'styled-components';

const ContentBlockSC = styled(Box)`
  width: 100%;
  max-width: 45.75rem;

  &.page__ContentBlock--compact {
    max-width: 30rem;
  }

  border: 0.0625rem solid #eaeaea;
  background-color: #ffffff;
  border-radius: 0.25rem;

  margin: 1.25rem auto;
  padding: 2.5rem 3.5rem;

  box-shadow: ${(props) => (props.showShadow ? '0 0 0 #FFFFFF' : 'none')};
  animation: ${(props) => (props.showShadow ? 'pulsate 1.6s ease-out 1' : 'none')};

  @keyframes pulsate {
    0% {
      box-shadow: 0 0 0 #ffffff;
    }
    50% {
      box-shadow: 0 0 0.25rem 0.25rem #a0bbf8;
    }
    100% {
      box-shadow: 0 0 0 #ffffff;
    }
  }

  @media (max-width: 767px) {
    padding: 1.5rem 1.75rem;
    margin: 1rem auto;
  }
`;

const ContentBlock = ({ compact, children, ...rest }) => (
  <ContentBlockSC className={compact ? 'page__ContentBlock--compact' : ''} {...rest}>
    {children}
  </ContentBlockSC>
);

export default ContentBlock;
